module.exports = __webpack_public_path__ + "media/img/search-ico-24ac02f04df9e7fd1ee050397f90f574.svg";